require('./admin-panel/main');
require('./app/main');

import app from "./appInstance";

const el = document.getElementById("app");
if (el) {
    app.mount("#app");
}
